import { useEffect } from "react";
import { useFormatTemplateStore } from "@/state/formatTemplateStore";
import { FontSizes } from "@/utils/formatTemplate/formatTemplate";
import FontRow from "./FontRow";
import Ring from "@/components/ui/Ring";

export default function FontsStep() {
  const fontsSection = useFormatTemplateStore((state) => state.fontsSection);
  const { updateFontProperty, updateAnswered } = useFormatTemplateStore();

  useEffect(() => {
    updateAnswered(2, 8);
  }, [fontsSection]);


  return (
    <Ring className="p-4 mt-10 flex flex-col gap-8">
      <div className="flex gap-8">
        {/* Font Section */}
        <div className="flex-1">
          <div className="flex w-full items-center gap-4 py-1 mb-2 border-b border-black">
            <div className="w-50"></div>
            <div className="w-40 text-sm font-semibold text-gray-700">Style:</div>
            <div className="w-40 text-sm font-semibold text-gray-700">Size:</div>
            <div className="w-30 text-sm font-semibold text-gray-700">Color:</div>
            <div className="w-24 text-sm font-semibold text-gray-700">Features:</div>
          </div>

          <FontRow
            title="Slide Title"
            style={fontsSection.slideTitle.style}
            size={fontsSection.slideTitle.size}
            color={fontsSection.slideTitle.color}
            bold={fontsSection.slideTitle.bold}
            italic={fontsSection.slideTitle.italic}
            underline={fontsSection.slideTitle.underline}
            onStyleChange={(value) => updateFontProperty("slideTitle", "style", value)}
            onSizeChange={(value) => updateFontProperty("slideTitle", "size", value)}
            onColorChange={(value) => updateFontProperty("slideTitle", "color", value)}
            onBoldChange={(value) => updateFontProperty("slideTitle", "bold", value)}
            onItalicChange={(value) => updateFontProperty("slideTitle", "italic", value)}
            onUnderlineChange={(value) => updateFontProperty("slideTitle", "underline", value)}
            fontSizes={FontSizes}
          />

          <FontRow
            title="Slide Sub-Title"
            style={fontsSection.slideSubTitle.style}
            size={fontsSection.slideSubTitle.size}
            color={fontsSection.slideSubTitle.color}
            bold={fontsSection.slideSubTitle.bold}
            italic={fontsSection.slideSubTitle.italic}
            underline={fontsSection.slideSubTitle.underline}
            onStyleChange={(value) => updateFontProperty("slideSubTitle", "style", value)}
            onSizeChange={(value) => updateFontProperty("slideSubTitle", "size", value)}
            onColorChange={(value) => updateFontProperty("slideSubTitle", "color", value)}
            onBoldChange={(value) => updateFontProperty("slideSubTitle", "bold", value)}
            onItalicChange={(value) => updateFontProperty("slideSubTitle", "italic", value)}
            onUnderlineChange={(value) => updateFontProperty("slideSubTitle", "underline", value)}
            fontSizes={FontSizes}
          />

          <FontRow
            title="Key Take-Aways"
            style={fontsSection.keyTakeAways.style}
            size={fontsSection.keyTakeAways.size}
            color={fontsSection.keyTakeAways.color}
            bold={fontsSection.keyTakeAways.bold}
            italic={fontsSection.keyTakeAways.italic}
            underline={fontsSection.keyTakeAways.underline}
            onStyleChange={(value) => updateFontProperty("keyTakeAways", "style", value)}
            onSizeChange={(value) => updateFontProperty("keyTakeAways", "size", value)}
            onColorChange={(value) => updateFontProperty("keyTakeAways", "color", value)}
            onBoldChange={(value) => updateFontProperty("keyTakeAways", "bold", value)}
            onItalicChange={(value) => updateFontProperty("keyTakeAways", "italic", value)}
            onUnderlineChange={(value) => updateFontProperty("keyTakeAways", "underline", value)}
            fontSizes={FontSizes}
          />

          <FontRow
            title="Placeholder Title"
            style={fontsSection.placeholderTitle.style}
            size={fontsSection.placeholderTitle.size}
            color={fontsSection.placeholderTitle.color}
            bold={fontsSection.placeholderTitle.bold}
            italic={fontsSection.placeholderTitle.italic}
            underline={fontsSection.placeholderTitle.underline}
            onStyleChange={(value) => updateFontProperty("placeholderTitle", "style", value)}
            onSizeChange={(value) => updateFontProperty("placeholderTitle", "size", value)}
            onColorChange={(value) => updateFontProperty("placeholderTitle", "color", value)}
            onBoldChange={(value) => updateFontProperty("placeholderTitle", "bold", value)}
            onItalicChange={(value) => updateFontProperty("placeholderTitle", "italic", value)}
            onUnderlineChange={(value) => updateFontProperty("placeholderTitle", "underline", value)}
            fontSizes={FontSizes}
          />

          <FontRow
            title="Placeholder Sub-Title"
            style={fontsSection.placeholderSubTitle.style}
            size={fontsSection.placeholderSubTitle.size}
            color={fontsSection.placeholderSubTitle.color}
            bold={fontsSection.placeholderSubTitle.bold}
            italic={fontsSection.placeholderSubTitle.italic}
            underline={fontsSection.placeholderSubTitle.underline}
            onStyleChange={(value) => updateFontProperty("placeholderSubTitle", "style", value)}
            onSizeChange={(value) => updateFontProperty("placeholderSubTitle", "size", value)}
            onColorChange={(value) => updateFontProperty("placeholderSubTitle", "color", value)}
            onBoldChange={(value) => updateFontProperty("placeholderSubTitle", "bold", value)}
            onItalicChange={(value) => updateFontProperty("placeholderSubTitle", "italic", value)}
            onUnderlineChange={(value) => updateFontProperty("placeholderSubTitle", "underline", value)}
            fontSizes={FontSizes}
          />


          <FontRow
            title="Placeholder Axis Labels"
            style={fontsSection.placeholderAxisLabels.style}
            size={fontsSection.placeholderAxisLabels.size}
            color={fontsSection.placeholderAxisLabels.color}
            bold={fontsSection.placeholderAxisLabels.bold}
            italic={fontsSection.placeholderAxisLabels.italic}
            underline={fontsSection.placeholderAxisLabels.underline}
            onStyleChange={(value) => updateFontProperty("placeholderAxisLabels", "style", value)}
            onSizeChange={(value) => updateFontProperty("placeholderAxisLabels", "size", value)}
            onColorChange={(value) => updateFontProperty("placeholderAxisLabels", "color", value)}
            onBoldChange={(value) => updateFontProperty("placeholderAxisLabels", "bold", value)}
            onItalicChange={(value) => updateFontProperty("placeholderAxisLabels", "italic", value)}
            onUnderlineChange={(value) => updateFontProperty("placeholderAxisLabels", "underline", value)}
            fontSizes={FontSizes}
          />

          <div className="mt-8">
          <FontRow
            title="Source"
            style={fontsSection.source.style}
            size={fontsSection.source.size}
            color={fontsSection.source.color}
            bold={fontsSection.source.bold}
            italic={fontsSection.source.italic}
            underline={fontsSection.source.underline}
            onStyleChange={(value) => updateFontProperty("source", "style", value)}
            onSizeChange={(value) => updateFontProperty("source", "size", value)}
            onColorChange={(value) => updateFontProperty("source", "color", value)}
            onBoldChange={(value) => updateFontProperty("source", "bold", value)}
            onItalicChange={(value) => updateFontProperty("source", "italic", value)}
            onUnderlineChange={(value) => updateFontProperty("source", "underline", value)}
            fontSizes={FontSizes}
          />

          <FontRow
            title="Footnotes"
            style={fontsSection.footnotes.style}
            size={fontsSection.footnotes.size}
            color={fontsSection.footnotes.color}
            bold={fontsSection.footnotes.bold}
            italic={fontsSection.footnotes.italic}
            underline={fontsSection.footnotes.underline}
            onStyleChange={(value) => updateFontProperty("footnotes", "style", value)}
            onSizeChange={(value) => updateFontProperty("footnotes", "size", value)}
            onColorChange={(value) => updateFontProperty("footnotes", "color", value)}
            onBoldChange={(value) => updateFontProperty("footnotes", "bold", value)}
            onItalicChange={(value) => updateFontProperty("footnotes", "italic", value)}
            onUnderlineChange={(value) => updateFontProperty("footnotes", "underline", value)}
            fontSizes={FontSizes}
          />
          </div>


            {/* <div className="flex gap-4">
              <div className="">
                <div className="h-18"></div>
                <FontRow
                  title="Source"
                  style={fontsSection.source.style}
                  size={fontsSection.source.size}
                  color={fontsSection.source.color}
                  bold={fontsSection.source.bold}
                  italic={fontsSection.source.italic}
                  underline={fontsSection.source.underline}
                  onStyleChange={(value) => updateFontProperty("source", "style", value)}
                  onSizeChange={(value) => updateFontProperty("source", "size", value)}
                  onColorChange={(value) => updateFontProperty("source", "color", value)}
                  onBoldChange={(value) => updateFontProperty("source", "bold", value)}
                  onItalicChange={(value) => updateFontProperty("source", "italic", value)}
                  onUnderlineChange={(value) => updateFontProperty("source", "underline", value)}
                  fontSizes={FontSizes}
                />

                <FontRow
                  title="Footnotes"
                  style={fontsSection.footnotes.style}
                  size={fontsSection.footnotes.size}
                  color={fontsSection.footnotes.color}
                  bold={fontsSection.footnotes.bold}
                  italic={fontsSection.footnotes.italic}
                  underline={fontsSection.footnotes.underline}
                  onStyleChange={(value) => updateFontProperty("footnotes", "style", value)}
                  onSizeChange={(value) => updateFontProperty("footnotes", "size", value)}
                  onColorChange={(value) => updateFontProperty("footnotes", "color", value)}
                  onBoldChange={(value) => updateFontProperty("footnotes", "bold", value)}
                  onItalicChange={(value) => updateFontProperty("footnotes", "italic", value)}
                  onUnderlineChange={(value) => updateFontProperty("footnotes", "underline", value)}
                  fontSizes={FontSizes}
                />
              </div> */}
            {/* Approach Section */}
            {/* <div className="w-60">
              <ApproachSection
                text={
                  <div className="text-sm leading-6 space-y-3">
                    <p>
                      <strong>Centralized</strong> — Collates <em>all</em> footnotes and sources from the slide's
                      placeholders into a single <strong>Notes</strong> (and <strong>Sources</strong>) block at the
                      bottom. The placeholder <strong>Sub-Title</strong> shows superscripts (e.g., <sup>1</sup>,
                      <sup>2</sup>) to indicate which notes apply to the placeholder.
                    </p>
                    <p>
                      <strong>Decentralized</strong> — Footnotes (and sources) appear{" "}
                      <strong>directly beneath each placeholder</strong> they relate to. Clear local context, but can
                      add visual clutter and create uneven spacing.
                    </p>
                    <p>
                      <strong>Your choice</strong> — Select whether this template places notes/sources in one
                      centralized block with sub-title superscripts, or inline under each placeholder.
                    </p>
                  </div>
                }
                sourceApproach={fontsSection.source.approach}
                footnotesApproach={fontsSection.footnotes.approach}
                onSourceApproachChange={(approach) => updateFontProperty("source", "approach", approach)}
                onFootnotesApproachChange={(approach) => updateFontProperty("footnotes", "approach", approach)}
              />
            </div> */}
          </div>
        </div>
    </Ring>
  );
}
